import { getAgentFunTokenPrice } from '@cronos-app/api';
import type { ChainId } from '@cronos-app/sdk';
import { getContractAddress, utils } from '@cronos-app/sdk';
import { Token } from '@ui/config/token/types';

import type { TokenOption, TokenPriceFetcher } from '../types';

export const agentFunTokenFetcher = (chainId: ChainId): TokenPriceFetcher => ({
  fetchPrice: async () =>
    getAgentFunTokenPrice(
      utils.getLayerOfChain(chainId),
      getContractAddress(chainId, 'AgentFun'),
    ),
  supportsToken: (token: TokenOption) => token === Token.agentFun,
});
